import { status } from 'skin/event/status';
import category from './category';
import cpart from './cpart';

const setInput = (obj, ms, story, data, d, action) => {
	switch (obj.name) {
		case 'categoryId':
			return category(obj, ms, story, data, d, action);
		case 'cPartId':
			return cpart(obj, ms, story, data, d, action);
		default:
			return status.action;
	}
};

export default setInput;
